const STEP_COUNT = 3

export function deriveCurrentStep(
  parentEndpointId: string | null | undefined,
  childCount: number
): number {
  if (!parentEndpointId) return 1
  if (childCount === 0) return 2
  return STEP_COUNT
}
